import PropTypes from 'prop-types';

import { useTownAssets } from '../../stores';
import { Button } from '../buttons';

import Column from './Column';
import FullPopup from './FullPopup';
import Row from './Row';

const WarnPopup = function WarnPopup(props) {
  const {
    contentClassName = 'h-full w-full min-h-36 relative overflow-hidden flex flex-col gap-2',
    warning,
    onClose,
    title,
    name,
  } = props;
  const { assets } = useTownAssets();
  const { translate } = assets;

  return (
    <FullPopup
      title={title}
      contentClassName={contentClassName}
      onClose={onClose}
      small
      className="min-w-[300px]"
      titleBar={!!title}
      name={name}
    >
      <Column
        crossStart
        className="flex-1"
      >
        <span className="overflow-y-auto my-auto">{warning}</span>
      </Column>

      <Row gap={6} evenly>
        <Button
          onClick={onClose}
          imgSrc="/images/svg/gui/check.svg"
          label={translate('ok')}
          baseColor
        />
      </Row>
    </FullPopup>
  );
};

WarnPopup.propTypes = {
  contentClassName: PropTypes.string,
  title: PropTypes.string,
  warning: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  onClose: PropTypes.func,
  name: PropTypes.string,
};

export default WarnPopup;
